import {
    IItem,
} from '../types';
import {
    IProps,
} from './types';

import classNames from 'classnames';
import React, {
    FC,
    useMemo,
} from 'react';

import {
    DotsButton,
} from 'components/buttons';

import DataCell from './DataCell';
import OpenButtonMobile from './OpenButtonMobile';

import {
    formatChildren,
} from './functions';

import styles from './Row.module.scss';

const Row: FC<IProps<IItem>> = (props) => {
    const children = useMemo(() => {
        return formatChildren(props.children, props.columns, props.columnsEnum);
    }, [props.children, props.columns, props.columnsEnum]);

    const onClick = () => {
        if (!props.isMobile) {
            return;
        }

        props.onOpenMobile?.();
    };

    return (
        <div
            ref={props.dragRef}
            className={classNames(styles.row, props.className)}
            style={props.style}
            onClick={onClick}
            {...props.dragAttributes}
        >
            <div
                className={styles.content}
                style={props.gridStyle}
            >
                {[
                    ...props.columns
                        .map((column, columnIndex) =>
                            <DataCell
                                key={column}
                                className={props.cellClassName}
                                isMobile={props.isMobile}
                                option={props.formatColumnOption(column, props.isMobile)}
                                maxRowWidthDesktop={props.maxRowWidthDesktop}
                                maxRowWidthMobile={props.maxRowWidthMobile}
                            >
                                {children?.[columnIndex]}
                            </DataCell>
                        ),
                ]}
            </div>
            {props.additionalContent}
            <div className={styles.action}>
                {
                    props.isMobile ?
                        (
                            props.onOpenMobile &&
                            <OpenButtonMobile isMobile={props.isMobile}/>
                        ) :
                        (
                            props.optionsDesktop &&
                            <DotsButton
                                className={styles.dotsButton}
                                options={
                                    props.optionsDesktop.map((option) => {
                                        return {
                                            key: option.key,
                                            label: option.label,
                                            isHidden: option.isHidden,
                                            to: option.to,
                                            onClick: option.onClick,
                                        };
                                    })
                                }
                            />
                        )
                }
            </div>
        </div>
    );
};

export default Row;
